import newsletter from '@carwow/inject-newsletter';
import subscription from '@carwow/inject-subscription';
import desktopAds from '@carwow/inject-desktop-ads';
import digiteka from '@carwow/inject-digiteka';
import mobileAds from '@carwow/inject-mobile-ads';
import sideContent from '@carwow/inject-side-content';
import subscriptionAndNewsletter from '@carwow/inject-subscription-and-newsletter';
import teads from '@carwow/inject-teads';

export default [
  ...mobileAds,
  ...newsletter,
  ...subscription,
  ...subscriptionAndNewsletter,
  ...desktopAds,
  ...digiteka, // needs to run after ads
  ...sideContent,
  ...teads,
];
